import '../assets/css/module-map.css';
import { useState } from 'react'
import { ReactComponent as Korea } from '../assets/images/map-korea.svg'
import { ReactComponent as City } from '../assets/images/map-boul.svg'
import { useRef, useEffect } from 'react';
import { gsap } from "gsap";
import { useGSAP } from '@gsap/react';
import { useGoogleSheetData } from '../data/googleSheetApi'

export default function Map() {

    const { data, isLoading, error } = useGoogleSheetData();
    const [selectedRegion, setSelectedRegion] = useState('seoul');
    const container = useRef();

    // 버튼 클릭 시 스크롤 이동
    useEffect(() => {
      if (data) {  // data가 있을 때만 실행
        document.querySelector('.map-view > div').scrollTo(0,0);
      }
    }, [selectedRegion, data])

    // 애니메이션
    gsap.registerPlugin(useGSAP);
    
    useGSAP(() => {
      // 컴포넌트가 마운트된 후에 실행
      if (!isLoading && data) {
        gsap.to('.boul', { 
          y: 5, 
          repeat: -1, 
          yoyo: true, 
          duration: 0.7
        });
      }
    }, { scope: container, dependencies: [isLoading, data] });

    // 로딩 중이거나 에러 발생 시 처리
    if (isLoading) return <div>데이터를 불러오는 중...</div>;
    if (error) return <div>에러가 발생했습니다: {error}</div>;
    if (!data) return <div>데이터가 없습니다.</div>;

    // 선택된 지역의 데이터를 가져오는 함수
    const selectedData = data.find((city) => city.region === selectedRegion);


    return (
        <div ref={container} id='map-module' className='flex flex-between'>
            <div id='map-box'>
                <Korea width="100%" height="100%" />
                <button className='boul seoul' onClick={() => setSelectedRegion('seoul')}><City/></button>
                <button className='boul incheon' onClick={() => setSelectedRegion('incheon')}><City/></button>
                <button className='boul gyeonggi' onClick={() => setSelectedRegion('gyeonggi')}><City/></button>
                <button className='boul gangwon' onClick={() => setSelectedRegion('gangwon')}><City/></button>
                <button className='boul chungbuk' onClick={() => setSelectedRegion('chungbuk')}><City/></button>
                <button className='boul chungnam' onClick={() => setSelectedRegion('chungnam')}><City/></button>
                <button className='boul daejeon' onClick={() => setSelectedRegion('daejeon')}><City/></button>
                <button className='boul gyeongbuk' onClick={() => setSelectedRegion('gyeongbuk')}><City/></button>
                <button className='boul gyeongnam' onClick={() => setSelectedRegion('gyeongnam')}><City/></button>
                <button className='boul daegu' onClick={() => setSelectedRegion('daegu')}><City/></button>
                <button className='boul ulsan' onClick={() => setSelectedRegion('ulsan')}><City/></button>
                <button className='boul busan' onClick={() => setSelectedRegion('busan')}><City/></button>
                <button className='boul jeonbuk' onClick={() => setSelectedRegion('jeonbuk')}><City/></button>
                <button className='boul jeonnam' onClick={() => setSelectedRegion('jeonnam')}><City/></button>
                <button className='boul gwangju' onClick={() => setSelectedRegion('gwangju')}><City/></button>
                <button className='boul jeju' onClick={() => setSelectedRegion('jeju')}><City/></button>
            </div>
            <div className='map-view'>
              <div>
                <div className='citycard'>
                    <h4>{selectedData.title}</h4>
                    <div className='card-box flex flex-between'>
                      <div className='count-box'>
                        함께한 어르신
                        <p className='point'>{selectedData.people.toLocaleString('ko-KR')}명</p>
                      </div>
                      <div className='count-box'>
                        본죽 나눔 수량
                        <p className='point'>{selectedData.count.toLocaleString('ko-KR')}그릇</p>
                      </div>
                    </div>
                    <div className='citytable'>
                      <p className='smail-title'>나눔 가맹점</p>
                      <table>
                        <thead></thead>
                        <tbody>
                          {selectedData.table.map((disc,i) => (
                              <tr className='table-gap' key={i}>
                                <td className='table-key'>{disc.year}</td>
                                <td>{disc.store.join(', ')}</td>
                              </tr>
                            ))
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>
              </div>
            </div>
      </div>
    );
  };
  